// extracted by mini-css-extract-plugin
export var blue = "_47-h";
export var brand = "_47-d";
export var darkGrey = "_47-g";
export var disabled = "_47-6";
export var disabledSubtle = "_47-7";
export var error = "_47-8";
export var green = "_47-i";
export var grey = "_47-f";
export var icon = "_47-0";
export var inherit = "_47-c";
export var lightGrey = "_47-e";
export var orange = "_47-k";
export var pink = "_47-m";
export var primary = "_47-1";
export var purple = "_47-n";
export var quaternary = "_47-4";
export var quinary = "_47-5";
export var red = "_47-l";
export var secondary = "_47-2";
export var success = "_47-b";
export var tertiary = "_47-3";
export var warning = "_47-9";
export var warningSecondary = "_47-a";
export var white = "_47-o";
export var yellow = "_47-j";